import { Button } from "@mui/material";
import { Icon } from "@iconify/react";

export const Assessment_Course_Head = (
  navigate,
  courseName,
  userID,
  fromdate,
  todate
) => [
  { field: "matrix_name", headerName: "Matrix", width: 200 },
  {
    field: "10thcount",
    headerName: "1 Star",
    width: 200,
    renderCell: (params) => {
      return (
        <Button
          sx={{
            backgroundColor: "#4A2574",
            borderRadius: 1,
            color: "white",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
          onClick={() =>
            navigate(
              `/my-workspace/grade-wise-report?course_name=${courseName}&userID=${userID}&grade_name=10&matrix_name=${params.row.matrix_name}&fromDate=${fromdate}&toDate=${todate}`
            )
          }
        >
          Count = {params.row["10thcount"] ?? "0"}
          <Icon icon={"ep:d-arrow-right"} width={16} height={16} />
        </Button>
      );
    },
  },
  {
    field: "20thcount",
    headerName: "2 Star",
    width: 200,
    renderCell: (params) => {
      return (
        <Button
          sx={{
            backgroundColor: "#4A2574",
            borderRadius: 1,
            color: "white",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
          onClick={() =>
            navigate(
              `/my-workspace/grade-wise-report?course_name=${courseName}&userID=${userID}&grade_name=20&matrix_name=${params.row.matrix_name}&fromDate=${fromdate}&toDate=${todate}`
            )
          }
        >
          Count = {params.row["20thcount"] ?? "0"}
          <Icon icon={"ep:d-arrow-right"} width={16} height={16} />
        </Button>
      );
    },
  },
  {
    field: "30thcount",
    headerName: "3 Star",
    width: 200,
    renderCell: (params) => {
      return (
        <Button
          sx={{
            backgroundColor: "#4A2574",
            borderRadius: 1,
            color: "white",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
          onClick={() =>
            navigate(
              `/my-workspace/grade-wise-report?course_name=${courseName}&userID=${userID}&grade_name=30&matrix_name=${params.row.matrix_name}&fromDate=${fromdate}&toDate=${todate}`
            )
          }
        >
          Count = {params.row["30thcount"] ?? "0"}
          <Icon icon={"ep:d-arrow-right"} width={16} height={16} />
        </Button>
      );
    },
  },
  {
    field: "40thcount",
    headerName: "4 Star",
    width: 200,
    renderCell: (params) => {
      return (
        <Button
          sx={{
            backgroundColor: "#4A2574",
            borderRadius: 1,
            color: "white",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
          onClick={() =>
            navigate(
              `/my-workspace/grade-wise-report?course_name=${courseName}&userID=${userID}&grade_name=40&matrix_name=${params.row.matrix_name}&fromDate=${fromdate}&toDate=${todate}`
            )
          }
        >
          Count = {params.row["40thcount"] ?? "0"}
          <Icon icon={"ep:d-arrow-right"} width={16} height={16} />
        </Button>
      );
    },
  },
  {
    field: "50thcount",
    headerName: "5 Star",
    width: 200,
    renderCell: (params) => {
      return (
        <Button
          sx={{
            backgroundColor: "#4A2574",
            borderRadius: 1,
            color: "white",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
          onClick={() =>
            navigate(
              `/my-workspace/grade-wise-report?course_name=${courseName}&userID=${userID}&grade_name=50&matrix_name=${params.row.matrix_name}&fromDate=${fromdate}&toDate=${todate}`
            )
          }
        >
          Count = {params.row["50thcount"] ?? "0"}
          <Icon icon={"ep:d-arrow-right"} width={16} height={16} />
        </Button>
      );
    },
  },
];
